module.exports = __webpack_public_path__ + "img/step2-3.e5f801dd.png";